import React, { createContext, useContext, useState } from "react";

// Utility function to create a data context
export const createDataContext = () => {
	const context = createContext(undefined);

	const useMultiImageDataContext = () => {
		const c = useContext(context);

		if (!c) {
			throw new Error(
				"useMultiImageDataContext is not inside a Provider with a value. Check that a component " +
					"is wrapped with the DataProvider."
			);
		}

		return c;
	};

	return [useMultiImageDataContext, context.Provider];
};

// Get the context and provider
const [useMultiImageData, CtxProvider] = createDataContext();

// Custom hook to retrieve context states
export { useMultiImageData };

// Data provider for MultiImageUploader component
export const MultiImageProvider = ({ children }) => {
	// States
	const [selectedImage, setSelectedImage] = useState(null);
	const [selectedImageName, setSelectedImageName] = useState(null);
	const [selectedImageIndex, setSelectedImageIndex] = useState(0);
	const [imageKeys, setImageKeys] = useState([]);
	const [imageSources, setImageSources] = useState({});
	const [fileUploads, setFileUploads] = useState({});
	const [uploadErrors, setUploadErrors] = useState({});

	return (
		<CtxProvider
			value={{
				selectedImage,
				setSelectedImage,
				selectedImageName,
				setSelectedImageName,
				selectedImageIndex,
				setSelectedImageIndex,
				imageKeys,
				setImageKeys,
				imageSources,
				setImageSources,
				fileUploads,
				setFileUploads,
				uploadErrors,
				setUploadErrors,
			}}
		>
			{children}
		</CtxProvider>
	);
};
